import Button, { ButtonProps } from "@mui/material/Button";
import { useOktaAuth } from "@okta/okta-react";

function SignInButton(props: ButtonProps) {
  const { oktaAuth } = useOktaAuth();

  return (
    <Button
      disableElevation
      variant="contained"
      size="small"
      onClick={async () => await oktaAuth.signInWithRedirect()}
      sx={{
        textTransform: "capitalize",
        filter: "opacity(0.9)",
        width: "50%",
        margin: (theme) => `${theme.spacing(1)} auto`,
        transition: "filter 0.2s ease-in",
        "&:hover": {
          filter: "opacity(1)",
        },
      }}
      {...props}
    >
      Se connecter
    </Button>
  );
}

export { SignInButton };
